import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '最新爆料', to: '/category/all' },
  { label: '明星动态', to: '/category/star' },
  { label: '网红圈', to: '/category/influencer' },
  { label: '影视综艺', to: '/category/screen' },
  { label: '带货打假', to: '/category/business' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    return location.pathname.startsWith(to);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="爆料吃瓜 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-line text-xl"></i>
            </span>
            <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
              爆料吃瓜
            </span>
          </Link>

          <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-3 py-2 font-label text-sm transition-colors ${
                  isActive(item.to)
                    ? 'bg-primary-100 font-medium text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/submit"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              <i className="ri-megaphone-line mr-1.5 text-base leading-none"></i>
              我要爆料
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="展开导航菜单"
              aria-expanded={open}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden"
          aria-label="移动端导航"
        >
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={`rounded-md px-3 py-2.5 font-label text-sm transition-colors ${
                  isActive(item.to)
                    ? 'bg-primary-100 font-medium text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/submit"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-md bg-primary-500 px-3 py-2.5 text-center font-label text-sm font-medium text-background-50"
            >
              我要爆料
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}